/* AUTO-GENERATED by app/tools/convert-templates.mjs */

/** docs_id всех перенесённых форм (см. DOC_FORMS в ./index). */
export const DOC_IDS: ReadonlySet<string> = new Set([
  "anest_det",
  "anest_pred",
  "anest_vzr",
  "check",
  "dnev",
  "dogovor",
  "ekg",
  "foto_video",
  "ids12",
  "ids34",
  "ids_no",
  "karta_a",
  "karta_s",
  "karta_s_2023",
  "napr057",
  "nazn_s",
  "obosn_s",
  "opros_list",
  "optkorr",
  "pervosm_a",
  "pervosm_s",
  "preprot",
  "pril",
  "protokt",
  "protuzi_a",
  "statkarta",
  "stat_karta",
  "stat_s",
  "sved",
  "temp",
  "terap",
  "titul_a",
  "titul_s",
  "vnexp",
  "vyp_a",
  "vyp_s",
  "zayav_vyb",
]);
